// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"eabaceb3","977":"480b0946"}[chunkId] + ".chunk.js";
};